import { render } from "./CodeEditorModal.vue?vue&type=template&id=52e23468&scoped=true"
import script from "./CodeEditorModal.vue?vue&type=script&lang=js"
export * from "./CodeEditorModal.vue?vue&type=script&lang=js"

import "./CodeEditorModal.vue?vue&type=style&index=0&id=52e23468&scoped=true&lang=css"

import exportComponent from "/usr/app/workspace-stack/frontend-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52e23468"]])

export default __exports__